import CommonService from '../../common/services/common-service';
import vxSpinner from '../../common/vx-spinner/vx-spinner.vue';
import globals from '../../common/globals';

export default {
  name: 'vx-terms-condition',
  components: {
    vxSpinner,
  },
  props: [],
  data() {
    return {
      commonService: new CommonService(),
      termsConditionData: '',
      globals,
    };
  },
  computed: {

  },
  mounted() {
    this.$refs.spinner.showSpinner();
    this.commonService.getTermsAndCondition({}, this.handleTermsConditionResponse, this.handleTermsConditionError);
  },
  methods: {
    /**
     * Terms and Consition data is taken from response and shown in the view
     * @param {object} response
     */
    handleTermsConditionResponse(response) {
      this.$refs.spinner.hideSpinner();
      const status = response.status;
      const data = response.data;
      if (status) {
        this.termsConditionData = data;
      }
    },
    /**
     * On Error of terms and condition call, Hide the spinner
     * @param {object} error
     */
    handleTermsConditionError(error) {
      this.$refs.spinner.hideSpinner();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/vx-terms-condition/vx-terms-condition.js